"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.types = void 0;
exports.types = {
    integer: function isInteger(instance) {
        return typeof instance === 'number' && instance % 1 === 0;
    },
    number: function isNumber(instance) {
        return typeof instance === 'number' && isFinite(instance);
    },
    string: function isString(instance) {
        return typeof instance === 'string';
    },
    array: function isArray(instance) {
        return Array.isArray(instance);
    },
    object: function isObject(instance) {
        return (!!instance && typeof instance === 'object' && !Array.isArray(instance));
    },
    boolean: function isBoolean(instance) {
        return typeof instance === 'boolean';
    },
    null: function isNull(instance) {
        return instance === null;
    }
};
